export const APP_ROLES = Object.freeze({
  SUPER_ADMIN: "Super-Admin",
  ADMIN: "Admin",
  SUB_ADMIN: "Sub-Admin",
  OPERATION: "Operation",
});

export const ACCESS_RESOURCES = Object.freeze({
  FINANCE: "finance",
  DASHBOARD: "dashboard",
  MERCHANTS: "merchants",
  TRANSACTIONS: "transactions",
  CUSTOMERS: "customers",
  MERCHANT_CHARGES: "merchant-charges",
  LEDGER: "ledger",
  SETTINGS: "settings",
  USER_MANAGEMENT: "user-management",
  WALLETS: "wallets",
  REFERRALS: "referrals",
});

const FULL_ACCESS = "*";

export const ROLE_PERMISSIONS = Object.freeze({
  [APP_ROLES.SUPER_ADMIN]: [FULL_ACCESS],
  [APP_ROLES.ADMIN]: [
    ACCESS_RESOURCES.DASHBOARD,
    ACCESS_RESOURCES.MERCHANTS,
    ACCESS_RESOURCES.SETTINGS,
    ACCESS_RESOURCES.USER_MANAGEMENT,
    ACCESS_RESOURCES.WALLETS,
    ACCESS_RESOURCES.REFERRALS,
  ],
  [APP_ROLES.SUB_ADMIN]: [
    ACCESS_RESOURCES.DASHBOARD,
    ACCESS_RESOURCES.TRANSACTIONS,
    ACCESS_RESOURCES.MERCHANT_CHARGES,
    ACCESS_RESOURCES.LEDGER,
    ACCESS_RESOURCES.USER_MANAGEMENT,
    ACCESS_RESOURCES.WALLETS,
    ACCESS_RESOURCES.REFERRALS,
  ],
  [APP_ROLES.OPERATION]: [FULL_ACCESS],
});

export const ALLOWED_LOGIN_ROLES = Object.freeze(Object.values(APP_ROLES));

export const AUTH_STORAGE_KEYS = Object.freeze([
  "token",
  "role",
  "userId",
  "firstName",
  "lastName",
  "email",
  "phone",
  "balance",
  "lastLoginDate",
  "isActive",
  "isTwoFaSetup",
  "isTwoFaEnabled",
]);

export const normalizeRole = (role) => (typeof role === "string" ? role.trim() : "");

export const isAllowedLoginRole = (role) => ALLOWED_LOGIN_ROLES.includes(normalizeRole(role));

export const getRolePermissions = (role) => ROLE_PERMISSIONS[normalizeRole(role)] || [];

export const hasResourceAccess = (role, resource) => {
  if (!resource) return true;

  const permissions = getRolePermissions(role);
  return permissions.includes(FULL_ACCESS) || permissions.includes(resource);
};

export const UNAUTHORIZED_ROLE_MESSAGE = `Access denied. Only Admin Accounts can log in.`;
